export enum RecordLibraryTransferStatus {
  SUCCESSFULL = 'successfull',
  FAILED = 'failed',
  AWAITING_INSPECTIONS_COMPLETION = 'awaitingInspectionsCompletion',
  IN_PROGRESS = 'inProgress',
}
